









































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import PanelActionButton, {
  PanelActionButtonItemType,
} from '@/components/atoms/PanelActionButton.vue';
import PanelTitle from '@/components/atoms/PanelTitle.vue';
import ProductMenuLinks from '@/components/molecules/ProductMenuLinks.vue';
import { i18n } from '@/plugins/i18n/i18n';
import { ProductMenu, ClickProductUrlEvent } from '@/types/type';

enum Menus {
  DISABLE_FAVORITE = 'menu-disable-favorite',
  UPDATE_FAVORITE = 'menu-update-favorite',
}

@Component({
  components: {
    PanelTitle,
    PanelActionButton,
    ProductMenuLinks,
  },
})
export default class PortalFavoriteMenusPanel extends Vue {
  private icon = 'star';
  private title = i18n.tc('portal.favorite');
  private sitemap = i18n.tc('common.menu');
  private nofavoritemsg = i18n.tc('portal.nofavoritemsg');
  private panel = 0;

  @Prop()
  private menus!: ProductMenu[];

  private getActionItems(): PanelActionButtonItemType[] {
    return this.menus.length
      ? [
          {
            title: i18n.tc('portal.updateFavorite'),
            event: Menus.UPDATE_FAVORITE,
          },
        ]
      : [
          {
            title: i18n.tc('portal.hideFavorite'),
            event: Menus.DISABLE_FAVORITE,
          },
        ];
  }

  @Emit('disable-favorite-action')
  private disableFavoriteMenu(): void {}

  @Emit('update-favorite-action')
  private updateFavoriteMenu(): void {}

  @Emit('favorite-menu-opened')
  private linkOpened(event: ClickProductUrlEvent): ClickProductUrlEvent {
    return event;
  }
}
